import React, { useContext, useState } from "react";
import { DISABLED_BUTTON_SUBMIT, instance4 } from "App/constants";

import { Grid, Paper, TableCell, TableRow } from "@material-ui/core";

import { stableSort, getComparator } from "App/Component/ui/datatable/utils";
import { useDatatables } from "App/hooks";
import { downloadPDF, headCellsFile, STYLE_MASTER_FA, urlDelete, urlGetFile, urlUpload } from "./helpers";

import {
  IconButtonDatatable,
  InputTextArea,
  Loading,
  MasterButton,
  ModalDeleteConfirm,
  TableWrapper,
} from "App/Component/ui";

import { FormContext } from "../../context/FormContext";
import { defaultToastError, defaultToastSuccess, isNull } from "App/utils/helpers";
import InputFileCustom from "App/Component/ui/input/InputFileCustom/InputFileCustom";
import { DownloadIcon, TrashIcon } from "App/Assets";

export default function TabFile() {
  const classes = STYLE_MASTER_FA();
  const SHOW_LOAD_BUTTON = {
    label: "Upload",
    color: "green",
    state: false,
    disabled: false,
  };
  const [downloadId, setdownloadId] = useState("");
  const [disabled, setDisabled] = useState(SHOW_LOAD_BUTTON);
  const [dataRemark, setDataRemark] = useState("");
  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false);
  const { dataFile, setDataFile, headData } = useContext(FormContext);
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const setNewData = async () => {
    setLoading(true);
    if(!isNull(headData.id)){
      const api = await instance4.get(`${urlGetFile}/${headData.id}`);
      const res = api.data;
      if(res.status === 200){
        setDataFile(res.body);
      }else{
        defaultToastError(res.message);
      }
    }else{
      setDataFile([]);
      defaultToastError("Fixed asset tidak ditemukan");
    }
    setLoading(false);
  }

  const {
    page,
    setQ,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: dataFile,
    orderByDefault: "nama_file",
    orderByRow: ["nama_file", "id"],
  });

  const handleClickUpload = async () => {
    setDisabled(DISABLED_BUTTON_SUBMIT);
    try {
      if (isNull(file)) {
        defaultToastError("Harap pilih file terlebih dahulu");
        setDisabled(SHOW_LOAD_BUTTON);
      } else {
        const newFormData = new FormData();
        newFormData.append("id", headData.id);
        newFormData.append("torFile", file);
        newFormData.append("remark", dataRemark);
        const res = await instance4.post(urlUpload, newFormData);
        if (res.data.status === 200) {
          await setNewData();
          setDisabled(SHOW_LOAD_BUTTON);
          defaultToastSuccess(res.data.message);
          setFile(null);
          setDataRemark("");
        } else {
          defaultToastError(res.data.message);
          setDisabled(SHOW_LOAD_BUTTON);
        }
      }
    } catch (error) {
      setDisabled(SHOW_LOAD_BUTTON);
      defaultToastError(error?.response?.data?.message);
    }
  };

  const deleteById = async (id) => {
    try {
      const api = await instance4.post(urlDelete, { id });
      if (api.data.status === 200) {
        return {
          state: true,
          message: api.data.message,
        };
      } else {
        return {
          state: false,
          message: api.data?.message,
        };
      }
    } catch (error) {
      return {
        state: false,
        message: error?.response?.data?.message,
      };
    }
  };

  async function deleteList() {
    const res = await deleteById(downloadId);

    if (res.state) {
      defaultToastSuccess(res.message);
      await setNewData();
    } else {
      defaultToastError(res.message);
    }
    setShowModalDeleteConfirm(false);
  }

  function handleClickDelete(row) {
    setdownloadId(row);
    setShowModalDeleteConfirm(!showModalDeleteConfirm);
  }

  return (
    <Paper
      className={classes.paper}
    >
      {showModalDeleteConfirm && (
        <ModalDeleteConfirm
          confirmHandle={() => deleteList()}
          setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
        />
      )}
      <p className="fw-600 mt-1">FILE FIXED ASSET</p>
      {/* <div  
      style={{
          display: headData.user_request === 0 ? "none" : "block",
        }}> */}
      {/* {headData.user_request === getLocalName()  || aksesFile ? ( */}
        <Grid container spacing={2}>
          <Grid
            item
            sm={12}
            style={{
              position: "relative",
            }}
          >
            <label
              htmlFor="fileTOR"
              style={{
                fontWeight: 400,
                color: "#BDBDBD",
                fontSize: "11px",
              }}
            >
              Pilih File
            </label>
            <InputFileCustom
              convertToBase64={false}
              label={"Upload File"}
              name={"fileFA"}
              id={"fileFA"}
              initialNameFile={file}
              setFile={setFile}
              accept={".jpg, .jpeg, .png, .xlsx, .docx, .pdf"}
            />
            <label
              style={{
                position: "absolute",
                left: "8px",
                fontWeight: 400,
                color: "#BDBDBD",
                fontSize: "11px",
              }}
            >
              *File yang diizinkan .jpg, .jpeg, .png, .xlsx, .docx, dan .pdf;
              Maksimal file berukuran 2MB
            </label>
          </Grid>
          <Grid item sm={10}>
            <InputTextArea
              name="remark"
              label="Catatan"
              id="remark"
              placeholder="Catatan File"
              value={dataRemark}
              onChange={(e) => setDataRemark(e.target.value)}
            />
          </Grid>
          <Grid item sm={2}>
            <MasterButton
              type="submit"
              name={disabled.label}
              disabled={disabled.state}
              color={disabled.color}
              size="lg"
              onClick={() => (disabled.disabled ? null : handleClickUpload())}
              style={{
                padding: "0.6rem 2rem",
                fontSize: "15px",
                marginTop: "25px",
              }}
            />
          </Grid>
        </Grid>
      {/* ) : (
        <></>
      )} */}

      {/* </div> */}
      <div className="mt-2">
      <Loading show={loading}/>
        <TableWrapper
          setQ={setQ}
          withExportButton={false}
          withAddButton={false}
          order={order}
          orderBy={orderBy}
          handleRequestSort={handleRequestSort}
          length={length}
          rows={dataFile}
          headCells={headCellsFile}
          page={page}
          setPage={setPage}
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
        >
          {stableSort(data, getComparator(order, orderBy))
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map((row, index) => {
              return (
                <TableRow
                  hover
                  tabIndex={-1}
                  key={index}
                  style={{
                    backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
                  }}
                >
                  <TableCell
                    component="th"
                    scope="row"
                    padding="none"
                    align="center"
                  >
                    {index + 1}.
                  </TableCell>

                  <TableCell
                    component="th"
                    scope="row"
                    padding="none"
                    align="center"
                  >
                    {/* {headData.user_request === getLocalName()  || aksesFile ?  ( */}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "7px",
                        }}
                      >
                        <IconButtonDatatable
                          onClick={() => downloadPDF(row.id, row.nama_file)}
                        >
                          <DownloadIcon />
                        </IconButtonDatatable>
                        <IconButtonDatatable
                          onClick={() => handleClickDelete(row.id)}
                        >
                          <TrashIcon />
                        </IconButtonDatatable>
                      </div>
                    {/* ) : (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "7px",
                        }}
                      >
                        <IconButtonDatatable
                          onClick={() => downloadPDF(row.id, row.name)}
                        >
                          <DownloadIcon />
                        </IconButtonDatatable>
                      </div>
                    )} */}
                  </TableCell>
                  <TableCell align="center">{row?.id}</TableCell>
                  <TableCell align="left">{row?.nama_file}</TableCell>
                  <TableCell align="left">{row?.remark}</TableCell>
                </TableRow>
              );
            })}
        </TableWrapper>
      </div>
    </Paper>
  );
}
